import Vue from 'vue'
import Vuetify from 'vuetify'
import VueMoment from 'vue-moment'
import CKEditor from 'ckeditor4-vue'
import VueClipboard from 'vue-clipboard2'
import Viewer from 'v-viewer'
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
import { fnCopy, fnCheckMission, fnBuildQuery, fnToNumber, fnFormatNumber, fnNumberInput, fnEventNumber } from './utils'
import router from './router'
import store, { actions, state } from './store'
import App from './App.vue'
import colors from 'vuetify/es5/util/colors'
import 'viewerjs/dist/viewer.css'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import i18n from './i18n'

Vue.prototype._ = _
Vue.config.productionTip = false

Vue.use(Vuetify)
Vue.use(Viewer)
Vue.use(VueMoment)
Vue.use(CKEditor)
Vue.use(VueClipboard)

import Editor from './components/Editor'
Vue.component('v-editor', Editor)
import Chart from './components/Chart'
Vue.component('v-chart', Chart)
import Upload from './components/Upload'
Vue.component('v-upload', Upload)
import Button from './components/Button'
Vue.component('v-btnc', Button)
import Gender from './components/Gender'
Vue.component('v-gender', Gender)
import Province from './components/Province'
Vue.component('v-province', Province)
import District from './components/District'
Vue.component('v-district', District)
import Ward from './components/Ward'
Vue.component('v-ward', Ward)
import RoleAccount from './components/RoleAccount'
Vue.component('v-roleAccount', RoleAccount)
import StatusAccount from './components/StatusAccount'
Vue.component('v-statusAccount', StatusAccount)
import Notification from './components/Notification'
Vue.component('v-notification', Notification)
import DatePicker from './components/DatePicker'
Vue.component('v-datePicker', DatePicker)
import DateTimePicker from "./components/DateTimePicker";
Vue.component("v-dateTimePicker", DateTimePicker);
import DatePickerRange from './components/DatePickerRange'
Vue.component('v-datePickerRange', DatePickerRange)
import StatusUser from './components/StatusUser'
Vue.component('v-statusUser', StatusUser)
import StatusBanner from './components/StatusBanner'
Vue.component('v-statusBanner', StatusBanner)
import TypeBanner from './components/TypeBanner'
Vue.component('v-typeBanner', TypeBanner)
import StatusGift from './components/StatusGift'
Vue.component('v-statusGift', StatusGift)
import TypeGift from './components/TypeGift'
Vue.component('v-typeGift', TypeGift)
import StatusPost from './components/StatusPost'
Vue.component('v-statusPost', StatusPost)
import StatusOrder from './components/StatusOrder'
Vue.component('v-statusOrder', StatusOrder)
import StatusReport from './components/StatusReport'
Vue.component('v-statusReport', StatusReport)
import StatusTopic from './components/StatusTopic'
Vue.component('v-statusTopic', StatusTopic)
import StatusDating from './components/StatusDating'
Vue.component('v-statusDating', StatusDating)
import TypeTopic from './components/TypeTopic'
Vue.component('v-typeTopic', TypeTopic)
import StatusPush from './components/StatusPush'
Vue.component('v-statusPush', StatusPush)
import TypeSponsor from './components/TypeSponsor'
Vue.component('v-typeSponsor', TypeSponsor)
import TypeSetting from './components/TypeSetting'
Vue.component('v-typeSetting', TypeSetting)
import TypeDiscovery from './components/TypeDiscovery'
Vue.component('v-typeDiscovery', TypeDiscovery)
import StatusDiscovery from './components/StatusDiscovery'
Vue.component('v-statusDiscovery', StatusDiscovery)
import TypeMint from './components/TypeMint'
Vue.component('v-typeMint', TypeMint)
import TypePost from './components/TypePost'
Vue.component('v-typePost', TypePost)

Vue.filter('mDateTime', v => Vue.moment.unix(v).format('HH:mm:ss DD/MM/YYYY'))
Vue.filter('mDate', v => Vue.moment.unix(v).format('DD/MM/YYYY'))
Vue.filter('mDateRange', v => v.length ? `${Vue.moment.unix(v[0]).format('DD/MM/YYYY')} ~ ${Vue.moment.unix(v[1]).format('DD/MM/YYYY')}` : '')
Vue.filter('mNumber', v => fnFormatNumber(v) || '-')
Vue.filter('mAddressFormat', (v, n) => v ? `${v.slice(0, n)}...${v.slice(v.length - n)}` : '-')

Vue.mixin({
	computed: mapState(Object.keys(state)),
	methods: {
		fnCopy, fnCheckMission, fnBuildQuery, fnToNumber, fnFormatNumber, fnNumberInput, fnEventNumber,
		...mapActions(Object.keys(actions))
	}
})

new Vue({
	i18n,
	store,
	router,
	vuetify: new Vuetify({ theme: { themes: { light: { primary: '#9c5aff', secondary: colors.grey } } } }),
	render: h => h(App)
}).$mount('#app')
